// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   DonateHero — /donate page hero
   Shorter than full-screen — wide banner feel matching design
   ============================================================ */

.dnhero {
  position: relative;
  height: clamp(400px, 75vh, 700px);
  background: var(--c-cream);
  overflow: hidden;
  isolation: isolate;
}

/* Background */
.dnhero__media {
  position: absolute;
  inset: 0;
  mix-blend-mode: multiply;
  z-index: -1;
}

.dnhero__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 68% center;
}

/* Scrim — heavy left fade, photo peeks through on right */
.dnhero__scrim {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 24%, rgba(244, 239, 230, 0.88) 38%, rgba(244, 239, 230, 0.28) 56%, rgba(244, 239, 230, 0.04) 74%),
    linear-gradient(to top, rgba(27, 27, 27, 0.15) 0%, rgba(27, 27, 27, 0) 40%);
}

/* Shell */
.dnhero__inner {
  position: relative;
  height: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: clamp(1rem, 2.5vw, 2.25rem);
  padding-top: 64px;
  z-index: 3;
}

/* Content */
.dnhero__content {
  max-width: 46rem;
  display: flex;
  flex-direction: column;
  gap: clamp(0.7rem, 1.2vw, 1rem);
}

/* Headline — very large, two-tone (set via inline style on each line) */
.dnhero__title {
  font-size: clamp(3rem, 9vw, 8rem);
  line-height: 0.88;
  margin: 0;
}

/* Rust rule + forge mark row */
.dnhero__rule-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-block: 0.2rem;
}

.dnhero__rule {
  display: block;
  width: clamp(2rem, 3.5vw, 3rem);
  height: 3px;
  background: var(--accent);
}

/* Body copy */
.dnhero__sub {
  font-family: var(--font-body);
  font-size: clamp(0.85rem, 1.1vw, 1rem);
  color: var(--c-ink);
  line-height: 1.7;
  max-width: 26rem;
  margin: 0;
}

/* Responsive */
@media (max-width: 991.98px) {
  .dnhero__img {
    object-position: 62% center;
  }
}

@media (max-width: 767.98px) {
  .dnhero {
    height: clamp(280px, 70vw, 420px);
  }
  .dnhero__inner {
    grid-template-columns: 1fr;
    padding-inline: var(--gutter);
  }
  .dnhero__rail {
    display: none;
  }
  .dnhero__content {
    max-width: 100%;
  }
  .dnhero__title {
    font-size: clamp(2.6rem, 12vw, 5rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DonateHero.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR;;+EAE6E;AAC/E;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,wEAAwE;AACxE;EACE,iCAAiC;EACjC,iBAAiB;EACjB,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,oCAAoC;EACtC;AACF","sourcesContent":["/* ============================================================\n   DonateHero — /donate page hero\n   Shorter than full-screen — wide banner feel matching design\n   ============================================================ */\n\n.dnhero {\n  position: relative;\n  height: clamp(400px, 75vh, 700px);\n  background: var(--c-cream);\n  overflow: hidden;\n  isolation: isolate;\n}\n\n/* Background */\n.dnhero__media {\n  position: absolute;\n  inset: 0;\n  mix-blend-mode: multiply;\n  z-index: -1;\n}\n\n.dnhero__img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 68% center;\n}\n\n/* Scrim — heavy left fade, photo peeks through on right */\n.dnhero__scrim {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 24%, rgba(244, 239, 230, 0.88) 38%, rgba(244, 239, 230, 0.28) 56%, rgba(244, 239, 230, 0.04) 74%),\n    linear-gradient(to top, rgba(27, 27, 27, 0.15) 0%, rgba(27, 27, 27, 0) 40%);\n}\n\n/* Shell */\n.dnhero__inner {\n  position: relative;\n  height: 100%;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  column-gap: clamp(1rem, 2.5vw, 2.25rem);\n  padding-top: 64px;\n  z-index: 3;\n}\n\n/* Content */\n.dnhero__content {\n  max-width: 46rem;\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.7rem, 1.2vw, 1rem);\n}\n\n/* Headline — very large, two-tone (set via inline style on each line) */\n.dnhero__title {\n  font-size: clamp(3rem, 9vw, 8rem);\n  line-height: 0.88;\n  margin: 0;\n}\n\n/* Rust rule + forge mark row */\n.dnhero__rule-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-block: 0.2rem;\n}\n\n.dnhero__rule {\n  display: block;\n  width: clamp(2rem, 3.5vw, 3rem);\n  height: 3px;\n  background: var(--accent);\n}\n\n/* Body copy */\n.dnhero__sub {\n  font-family: var(--font-body);\n  font-size: clamp(0.85rem, 1.1vw, 1rem);\n  color: var(--c-ink);\n  line-height: 1.7;\n  max-width: 26rem;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 991.98px) {\n  .dnhero__img {\n    object-position: 62% center;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .dnhero {\n    height: clamp(280px, 70vw, 420px);\n  }\n  .dnhero__inner {\n    grid-template-columns: 1fr;\n    padding-inline: var(--gutter);\n  }\n  .dnhero__rail {\n    display: none;\n  }\n  .dnhero__content {\n    max-width: 100%;\n  }\n  .dnhero__title {\n    font-size: clamp(2.6rem, 12vw, 5rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
